import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonOlList from '../../../common-components/common-ol-list';

const devRecList = {
    colorNumber: '#D83832',
    big: true,
    list: ['Жесткие требования к&nbsp;оперативности', 'Устаревший код'],
};

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="dev-rec-complex">
                <div className="dev-rec-complex__wrapper">
                    <div className="dev-rec-complex__grid">
                        <div className="dev-rec-complex__content">
                            <CommonTitle className="dev-rec-complex__title">Сложности</CommonTitle>
                            <CommonOlList
                                className="dev-rec-complex__list"
                                CommonOlList={devRecList}
                            />
                        </div>
                        <div className="dev-rec-complex__img">
                            <img
                                src="/images/svg/dev-rec/dev-rec-complex.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
